module.exports = __webpack_public_path__ + "img/marathon_premium.0c519130.jpg";